import "./StakingAbout.css";
import React, { useRef, useEffect } from "react";
// import "./features.css";
import svg1 from "../../assets/images/Icon.svg";
import svg2 from "../../assets/images/Icon-1.svg";
import svg3 from "../../assets/images/Icon-2.svg";
import nft from "../../assets/images/NFT.svg";
import feature from "../../assets/images/Feature Icon with circle.svg";
import feature1 from "../../assets/images/stakingFeature.png";
import feature2 from "../../assets/gifs/Indigo Glow.gif";
import feature3 from "../../assets/images/AssuranceCover.png";
import feature4 from "../../assets/images/ReaawdFeature.png";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

function StakingAbout() {
  const eachFeatureRef = useRef(null);
  const feature1_ref = useRef(null);
  const feature2_ref = useRef(null);
  const feature3_ref = useRef(null);
  const feature4_ref = useRef(null);

  useEffect(() => {
    const portArticle = eachFeatureRef.current;
    const feature1 = feature2_ref.current;
    const feature2 = feature1_ref.current;
    const feature3 = feature3_ref.current;
    const feature4 = feature4_ref.current;

    gsap.fromTo(
      ".each_Feature",
      {
        opacity: 0,
        y: 15,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        stagger: 0.3,
        scrollTrigger: {
          trigger: portArticle,
          start: "top 70%",
          end: "bottom 20%",
          toggleActions: "restart reverse restart reverse",
          // markers: true,
        },
      }
    );

    gsap.fromTo(
      ".feature1_Img",
      {
        opacity: 0,
        y: 25,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.7,
        stagger: 0.3,
        delay: 0.3,

        scrollTrigger: {
          trigger: feature2,
          start: "top 70%",
          end: "bottom 20%",
          toggleActions: "restart reverse restart reverse",
          // markers: true,
        },
      }
    );
    gsap.fromTo(
      ".feature1_Info",
      {
        opacity: 0,
        x: -15,
      },
      {
        opacity: 1,
        x: 0,
        duration: 1,
        stagger: 0.3,
        scrollTrigger: {
          trigger: feature2,
          start: "top 70%",
          end: "bottom 20%",
          toggleActions: "restart reverse restart reverse",
          // markers: true,
        },
      }
    );
    gsap.fromTo(
      ".feature2Img",
      {
        opacity: 0,
        y: 25,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.7,
        stagger: 0.3,
        delay: 0.3,

        scrollTrigger: {
          trigger: feature1,
          start: "top 70%",
          end: "bottom 20%",
          toggleActions: "restart reverse restart reverse",
          // markers: true,
        },
      }
    );
    gsap.fromTo(
      ".feature2Info",
      {
        opacity: 0,
        x: 25,
      },
      {
        opacity: 1,
        x: 0,
        duration: 0.7,
        stagger: 0.3,
        delay: 0.3,

        scrollTrigger: {
          trigger: feature1,
          start: "top 70%",
          end: "bottom 20%",
          toggleActions: "restart reverse restart reverse",
          // markers: true,
        },
      }
    );
    gsap.fromTo(
      ".feature3_Img",
      {
        opacity: 0,
        y: 25,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.7,
        stagger: 0.3,
        delay: 0.3,

        scrollTrigger: {
          trigger: feature3,
          start: "top 70%",
          end: "bottom 20%",
          toggleActions: "restart reverse restart reverse",
          // markers: true,
        },
      }
    );
    gsap.fromTo(
      ".feature3_Info",
      {
        opacity: 0,
        x: -15,
      },
      {
        opacity: 1,
        x: 0,
        duration: 1,
        stagger: 0.3,
        scrollTrigger: {
          trigger: feature3,
          start: "top 70%",
          end: "bottom 20%",
          toggleActions: "restart reverse restart reverse",
          // markers: true,
        },
      }
    );
    gsap.fromTo(
      ".feature4Img",
      {
        opacity: 0,
        y: 25,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.7,
        stagger: 0.3,
        delay: 0.3,

        scrollTrigger: {
          trigger: feature4,
          start: "top 70%",
          end: "bottom 20%",
          toggleActions: "restart reverse restart reverse",
          // markers: true,
        },
      }
    );
    gsap.fromTo(
      ".feature4Info",
      {
        opacity: 0,
        x: 25,
      },
      {
        opacity: 1,
        x: 0,
        duration: 0.7,
        stagger: 0.3,
        delay: 0.3,

        scrollTrigger: {
          trigger: feature4,
          start: "top 70%",
          end: "bottom 20%",
          toggleActions: "restart reverse restart reverse",
          // markers: true,
        },
      }
    );
  });
  return (
    <div className="stakingAbout" id="about">
      <div className="features">
        <div className="each-feature">
          <div className="feature feature1" ref={feature1_ref}>
            {" "}
            <div className="left align-left feature1_Info">
              <div
                className="feature-name days-one"
                style={{ color: "#ef7539" }}
              >
                Automatic Staking
              </div>
              <div className="feature-info">
                Experience the ease of automatic staking with our seamless
                system. Say goodbye to the hassle of manual intervention. Your
                INFINITY tokens{" "}
                <span style={{ color: "#17ccf8" }}>grow effortlessly </span>
                focus on what truly matters - allowing you to{" "}
                <span style={{ color: "#17ccf8" }}>
                  maximizing your returns.
                </span>
              </div>

              <div className="buttons">
                <button className="feature_btn">
                  Learn about Auto Staking
                </button>
              </div>
            </div>
            <div className="right feature1_Img">
              <img src={feature1} alt="" />
              <div className="blur1"></div>
            </div>
          </div>
          <div className="feature feature2" ref={feature2_ref}>
            <div className="right  feature2Img">
              <div className="blur2"></div>
              <img src={feature2} alt="" />
            </div>
            <div className="left align-right feature2Info" id="loopintegration">
              <div
                className="feature-name days-one"
                style={{ color: "#ef7539" }}
              >
                Earn a Fixed APY
              </div>
              <div className="feature-info " style={{ textAlign: "right" }}>
                Watch your investment grow with an impressive <br />
                <span style={{ color: "#17ccf8" }}>
                  APY of 13% for 1 Month, 23% for 3 Months, 33% for 6 Months,
                  43% for 12 Months <br />
                </span>{" "}
                respectively.
              </div>
              <div className="feature_buttons">
                <button className="button1">
                  {" "}
                  <a href="dexx">Enter App</a>{" "}
                </button>
                <button
                  className="button2"
                  style={{ border: "1px solid #ef7539" }}
                >
                  <a href="https://www.dropbox.com/scl/fi/ep16tithf2qexz10twyee/LOOP-OF-INFINITY-WHITEPAPER-April-Update.pdf?rlkey=a1i8hvzn9ncrhcsqfdtskfpxl&dl=0">
                    {" "}
                    Read Whitepaper
                  </a>
                </button>
              </div>
              <div className="hide-img">
                <img src={feature2} alt="" />
              </div>
            </div>
          </div>
          <div className="feature feature3" ref={feature3_ref}>
            <div className="left align-left feature3_Info">
              <div className="feature-name days-one">
                Safeguard your Future with <br />{" "}
                <span style={{ color: "#ef7539" }}>Assurance Cover</span>
              </div>
              <div className="feature-info">
                Protect your investment with our optional Assurance Cover.
                Choose from different coverage levels to suit your needs:
              </div>
              <div className="hide-img">
                <img src={feature3} alt="" />
              </div>
              <ul>
                {/* <span style={{ color: "#17ccf8" }}> */}
                <li style={{ color: "#17ccf8" }}>$10 for 20% coverage</li>
                <li style={{ color: "#17ccf8" }}>$20 for 40% coverage</li>
                <li style={{ color: "#17ccf8" }}>$40 for 100% coverage</li>
                {/* </span> */}
              </ul>
            </div>
            <div className="right feature3_Img">
              <img src={feature3} alt="" className="floatImgs" />{" "}
              <div className="blur3"></div>
            </div>
          </div>
          <div className="feature feature4" ref={feature4_ref}>
            <div className="blur4"></div>

            <div className="right  feature4Img">
              <img src={feature4} className="floatImgs" alt="" />
            </div>
            <div className="left align-right feature4Info" id="loopintegration">
              <div
                className="feature-name days-one"
                style={{ textAlign: "right" }}
              >
                Your Safety Net in Uncertainty with{" "}
                <span style={{ color: "#ef7539" }}>BuyBack</span>
              </div>
              <div className="feature-info" style={{ textAlign: "right" }}>
                For added peace of mind, we offer a BuyBack option. Get back
                into the game even if the unexpected happens.
              </div>
              <div className="hide-img">
                <img src={feature2} alt="" />
              </div>
              <ul style={{ textAlign: "right" }}>
                <li>
                  Initial Buyback Price: $0.0105 for the first 5,000 people,
                  $0.0095 for the rest
                </li>
                <li>
                  Monthly buyback is available only for users with insurance
                </li>
              </ul>
              <div className="feature_buttons">
                <button className="button1">
                  {" "}
                  <a href="dexx">Enter App</a>{" "}
                </button>
                <button
                  className="button2"
                  style={{ border: "1px solid #ef7539" }}
                >
                  <a href="https://www.dropbox.com/scl/fi/ep16tithf2qexz10twyee/LOOP-OF-INFINITY-WHITEPAPER-April-Update.pdf?rlkey=a1i8hvzn9ncrhcsqfdtskfpxl&dl=0">
                    {" "}
                    Read Whitepaper
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StakingAbout;
